module.exports = __webpack_public_path__ + "img/abounddata_logo.8f7a6603.svg";